Ext.define('SA.QuickReportViewController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.toolbar = new SA.view.QuickReportViewToolbar({model});
        this.view = Ext.widget({xtype: 'quick-report', projectView: model});
        this.projectView = SA.ProjectView.createHidden(this.view);

        this.initEvents();
    },

    initEvents() {
        this.model.on('remove', this.onModelDelete, this);
        this.activeState.onActive(this.onActive, this);
        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);
    },

    onActivateExportBtn(toolbarButton) {
        var config = new SA.QuickReportExportConfig({model: this.model});

        Ext.widget({xtype: 'arrow-export-menu', config, toolbarButton});
    },

    onActive() {
        SA.ProjectViewToolbar.setToolbar(this.toolbar);
        SA.ProjectView.show(this.projectView);
    },

    onModelDelete() {
        this.toolbar.destroy();
        this.projectView.destroy();
    }
});